/** Error shape returned by the API (mirrors the backend's standard error body). */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly requestId?: string;
  readonly details?: Record<string, string[]>;

  constructor(status: number, code: string, message: string, opts: { requestId?: string; details?: Record<string, string[]> } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.requestId = opts.requestId;
    this.details = opts.details;
  }

  get isForbidden() {
    return this.status === 403;
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}

/** Plain-language message for a non-technical user. Never a stack trace. */
export function friendlyMessage(error: unknown): string {
  if (isApiError(error)) {
    if (error.status === 403) return 'You do not have permission to view this information.';
    if (error.status === 404) return 'We could not find what you were looking for.';
    if (error.status === 0 || error.code === 'network_error') return 'The application service is not responding.';
    return error.message;
  }
  return 'Something went wrong. Please try again.';
}
